<template lang="pug">
v-dialog.modal-package-item(:value="value", @input="$emit('input', $event)", max-width="850px")
  v-card.pa-5
    v-row
      v-col
        h2.primary--text {{ $tc('PackageContent.packageQuantity', 1) }}
      v-spacer
      g-btn(icon, @click="$emit('input', false)")
        v-icon mdi-close
    div.table-container
      table(id="pckQtyTable")
        thead
          tr
            th
                th
                    h10 {{ `${$tc('Package._name', 1)} - ${getPackageHeader}` }}
            th
                h10 {{ $t('modalPackageQuantities.shippingQty') }}
        tbody
          template(v-for="(pc, i) in visibleContents")
            template(v-if="isNotDeleted(pc)")
              tr
                td
                  h5.primaryHover--text {{ `${$t('modalPackageQuantities.item')} ${findVisibleIndex(visibleContents, pc, 'itemNo') + 1}` }}
                td
                    v-text-field(:value="getValue(pc, localInstance)", type="number", min="0", @input="setValue($event, pc, localInstance)")
                td
                  v-text-field(:value="getShippingQuantity(pc, localInstance)", disabled)
    v-card-actions
      v-spacer
      g-btn(width="130px", color="primary", @click="submit") {{ $t('Common.submit') }}
      v-spacer

</template>

<style lang="scss" scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}
#pckQtyTable {
  border-spacing: 15px;
  border-collapse: separate;
  thead {
    th {
      max-width: 120px;
      width: 120px;
      min-width: 120px;
    }
  }
  tbody {
    td {
      ::v-deep .v-input__slot:before {
        border-color: var(--v-primary-base);
      }
      ::v-deep input {
        text-align: center;
        font-weight: 500;
      }
    }
  }
}
</style>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: ['entity', 'chips', 'invert', 'relation', 'path', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isDraft', 'isActive', 'value', 'pathPackages'],
  data: () => ({
    products: [],
    orderLines: [],
    localInstance: [],
  }),
  methods: {
    submit() {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: [...this.localInstance, ...this.notVisibleContents] });
      this.$emit('input', false);
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    isDeleted(element) {
      return _.get(element, 'entityState') === 2;
    },
    findVisibleIndex(visibleItems, element, path) {
      if (!visibleItems) return null;
      return visibleItems.findIndex(vp => {
        return vp[path] === element[path];
      });
    },
    getShippingQuantity({ packCont }, arrPackageContent) {
      const filtered = arrPackageContent.filter(content => content.itemNo === packCont);
      return _.reduce(filtered, (acc, { quantity }) => {
        return acc + Number(quantity);
      }, 0);
    },
    getValue( packCont , arrPackageContent) {
      const found = this.findPackageContent(packCont.itemNo, arrPackageContent);
      return found && found.quantity || 0;
    },
    findPackageContent(itemNo, arrPackageContent) {
      return arrPackageContent.find(content => ((content.itemNo === itemNo)));
      // return arrPackageContent.find(content => ((content.itemNo === itemNo) && (content.packageNo === packageNo))) || { entityState: 4, itemNo, packageNo, quantity: null };
    },
    setValue(value, packageC, arrPackageContent) {
        let found = this.findPackageContent(packageC.itemNo, arrPackageContent);
        let nValue = Number(value);
        if(packageC.product != null) packageC.product.entityState = 0;
        if(packageC.orderLine != null) packageC.orderLine.entityState = 0;
        if (!found) {
            found = { entityState: 4, itemNo: packageC.itemNo, packageNo: packageC.packageNo, package: this.parentInstance, product: packageC.product, orderLine: packageC.orderLine, quantity: nValue };
            arrPackageContent.push(found);
        } else {
            found.quantity = nValue;
            if (found.id) found.entityState = 3;
        }
    },
  },
  computed: {
    visibleContents() {
      return (this.instance || []).filter(this.isNotDeleted);
    },
    notVisibleContents() {
      return (this.instance || []).filter(this.isDeleted);
    },
    getPackageHeader() {
        return this.getPackaging + " " + this.getCaseId;
    },
    getPackaging() {
        return _.get(this.parentInstance, 'packaging');
    },
    getCaseId() {
        return _.get(this.parentInstance, 'caseIdentifier');
    },
  },
  created() {
    this.localInstance = _.cloneDeep(this.visibleContents);
  },
}
</script>
